export enum ConverterHandler {
    AudioFile = 'audio_file',
    RingBackTone = 'ringback_tone',
    DialByName = 'dial_by_name',
    ResponseMessage = 'response_message',
}
